var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import * as moment from 'moment';
import { SET_PLAYING, SET_CURRENT_CAMERA_POSITION, SET_CURRENT_SCENARIO_SECONDS_PER_TICK } from 'src/stores/viewer/config';
var ViewerTool = /** @class */ (function (_super) {
    __extends(ViewerTool, _super);
    function ViewerTool() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentScenarioId = '';
        _this.currentCameraPositionPlanetId = '';
        _this.currentTimesetIndex = -1;
        return _this;
    }
    Object.defineProperty(ViewerTool.prototype, "currentTimeset", {
        get: function () {
            return this.timesets[this.currentTimesetIndex];
        },
        enumerable: false,
        configurable: true
    });
    ViewerTool.prototype.togglePlaying = function () {
        this.setPlaying(!this.isPlaying);
    };
    ViewerTool.prototype.onChangeCurrentCameraPositionPlanetId = function (planetId) {
        this.setCurrentCameraPosition(planetId);
    };
    ViewerTool.prototype.onChangeCurrentTimeIndex = function () {
        if (!this.currentTimeset) {
            return;
        }
        this.setCurrentScenarioSecondsPerTick(this.currentTimeset.time);
    };
    ViewerTool.prototype.created = function () {
        var _this = this;
        this.currentScenarioId = this.currentScenario.id;
        this.currentCameraPositionPlanetId = this.currentCameraPosition;
        this.currentTimesetIndex = this.timesets.findIndex(function (timeset) {
            return timeset.time === _this.currentScenario.secondsPerTick;
        });
    };
    __decorate([
        State('Viewer')
    ], ViewerTool.prototype, "viewerState", void 0);
    __decorate([
        State(function (state) { return state.viewer.isPlaying; })
    ], ViewerTool.prototype, "isPlaying", void 0);
    __decorate([
        State(function (state) { return state.viewer.currentDate; })
    ], ViewerTool.prototype, "currentDate", void 0);
    __decorate([
        State(function (state) { return state.viewer.currentScenario; })
    ], ViewerTool.prototype, "currentScenario", void 0);
    __decorate([
        State(function (state) { return state.viewer.currentCameraPosition; })
    ], ViewerTool.prototype, "currentCameraPosition", void 0);
    __decorate([
        State(function (state) { return state.viewer.timesets; })
    ], ViewerTool.prototype, "timesets", void 0);
    __decorate([
        Mutation(SET_CURRENT_CAMERA_POSITION)
    ], ViewerTool.prototype, "setCurrentCameraPosition", void 0);
    __decorate([
        Mutation(SET_PLAYING)
    ], ViewerTool.prototype, "setPlaying", void 0);
    __decorate([
        Mutation(SET_CURRENT_SCENARIO_SECONDS_PER_TICK)
    ], ViewerTool.prototype, "setCurrentScenarioSecondsPerTick", void 0);
    ViewerTool = __decorate([
        Component({
            name: 'ViewerTool',
            filters: {
                date: function (value) {
                    return moment(value).format('YYYY-MM-DD HH:mm');
                }
            }
        })
    ], ViewerTool);
    return ViewerTool;
}(Vue));
export default ViewerTool;
;
